import spriteIcon from './sprite-icon/sprite-icon';
import media from './media/media';
import UiDropdown from './ui-dropdown/ui-dropdown';
import UiLoader from './ui-loader/ui-loader';
import UiButton from './ui-button/ui-button';
import UiBadge from './ui-badge/ui-badge';
import UiInput from './ui-input/ui-input';
import UiTextarea from './ui-textarea/ui-textarea';
import UiDatepicker from './ui-datepicker/ui-datepicker'
import UiMetro from './ui-metro/ui-metro';
import UiCitySuggest from './ui-city-suggest/ui-city-suggest';
import UiStreetSuggest from './ui-street-suggest/ui-street-suggest';
import UiSegmented from './ui-segmented/ui-segmented';
import UiTabs from './ui-tabs/ui-tabs';
import UiSelect from './ui-select/ui-select';
import UiRadiocards from './ui-radiocards/ui-radiocards';
import UiRadio from './ui-radio/ui-radio';
import RadioGroup from './radio-group/radio-group';
import UiNotification from './ui-notification/ui-notification';
import UiCheckbox from './ui-checkbox/ui-checkbox';
import UiCheckButton from './ui-checkbutton/ui-checkbutton';
import UiLink from './ui-link/ui-link';
import Swiper from './swiper/swiper';
import Modal from './modal/modal';
import ModalConfirm from './modal/modal-confirm';

// Directives
import clickOutside from './directives/click-outside';
import reached from './directives/reached';
import tooltip from './directives/tooltip';

// Filters
import { decl } from './decl';

const date = (d, {showYear = false} = {}) => { // преобразует в формат "ХХ месяц ХХХХ"
  if (!d) return '';

  const msPerDay = 24 * 60 * 60 * 1000;
  const daysDiff = Math.ceil(((new Date(d)).getTime() - Date.now())/msPerDay);
  const humanDays = ['сегодня', 'завтра'];
  if (humanDays[daysDiff]) {
    return humanDays[daysDiff];
  }
  const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
  // eslint-disable-next-line no-unused-vars
  const [date] = d.split('T');
  const [year, month, day] = date.split('-');
  return `${Math.round(day)} ${months[month-1]} ${showYear ? year : ''}`;
}

const fullDate = d => {
  if (!d) return;
  // eslint-disable-next-line no-unused-vars
  const [date] = d.split('T');
  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
}

const price = (value = '') => {
  let [rubs, cents] = value.toString().split('.');
  rubs = parseInt(`${rubs}`).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
  return `${rubs}${cents && cents > 0 ? '.' + (cents + '0').substring(0, 2) : ''}`;
};

const parseWorkSchedule = (store) => {
  return store.status === 'closed' ?
      'Временно закрыт'
      : store?.workSchedule.reduce((acc, item) => {
        acc.push(` ${item.workDays ? item.workDays : ''}: ${item.workTime ? item.workTime : ''}`);
        return acc;
      }, [])
          .join(', ')
          .toLowerCase();
}

const prettyPhone = phone => phone?.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5') || '';

const noBracesPhone = phone => phone?.replace(/[(, )]+/g, ' ') || '';

const mask = (value = '', mask = '######', keepMasked = true) => {
  const tokens = {
    '#': {pattern: /\d/},
  };

  let iMask = 0;
  let iValue = 0;
  let output = '';
  while (iMask < mask.length && iValue < value.length) {
    let cMask = mask[iMask];
    let masker = tokens[cMask];
    let cValue = value[iValue];
    if (masker) {
      if (masker.pattern.test(cValue)) {
        output += masker.transform ? masker.transform(cValue) : cValue;
        iMask++;
      }
      iValue++;
    } else {
      if (masker) {
        iMask++;
        cMask = mask[iMask];
      }
      if (keepMasked) output += cMask;
      if (cValue === cMask) iValue++;
      iMask++;
    }
  }
  return output;
}

export default {
  install(Vue) {
    Vue.component('media', media);
    Vue.component('f-sprite-icon', spriteIcon);
    Vue.component('ui-dropdown', UiDropdown);
    Vue.component('ui-loader', UiLoader);
    Vue.component('ui-button', UiButton);
    Vue.component('ui-badge', UiBadge);
    Vue.component('ui-input', UiInput);
    Vue.component('ui-textarea', UiTextarea);
    Vue.component('ui-metro', UiMetro);
    Vue.component('ui-city-suggest', UiCitySuggest);
    Vue.component('ui-street-suggest', UiStreetSuggest);
    Vue.component('ui-datepicker', UiDatepicker);
    Vue.component('ui-segmented', UiSegmented);
    Vue.component('ui-tabs', UiTabs);
    Vue.component('ui-select', UiSelect);
    Vue.component('ui-radiocards', UiRadiocards);
    Vue.component('ui-radio', UiRadio);
    Vue.component('radio-group', RadioGroup);
    Vue.component('ui-notification', UiNotification);
    Vue.component('ui-checkbox', UiCheckbox);
    Vue.component('ui-checkbutton', UiCheckButton);
    Vue.component('ui-link', UiLink);
    Vue.component('swiper', Swiper);
    Vue.component('modal', Modal);
    Vue.component('modal-confirm', ModalConfirm);

    Vue.directive('click-outside', clickOutside);
    Vue.directive('reached', reached);
    Vue.directive('tooltip', tooltip);

    Vue.filter('price', price);
    Vue.filter('decl', decl);
    Vue.filter('date', date);
    Vue.filter('fullDate', fullDate);
    Vue.filter('mask', mask);
    Vue.filter('parseWorkSchedule', parseWorkSchedule);
    Vue.filter('prettyPhone', prettyPhone);
    Vue.filter('noBracesPhone', noBracesPhone);
  }
};
